//icons
import AiChatAvatar from "../../assets/ai-chat-avatar.svg";
import TypingAnimation from "../../assets/typing-animation.svg";

//tools
import { $static } from "../../tools/helpers";

//styles
import styles from "./BotTyping.module.css";


const BotTyping = () => {
return (
    <div className={styles["bot-typing-container"]}>
        <img className={styles["bot-typing-animation"]} src={TypingAnimation} />
        <img className={styles["bot-typing-avatar"]} src={$static(AiChatAvatar)} />
    </div>
)
}

export default BotTyping